<template>
  <v-container>
      <v-row>
          <v-col>
              <v-row justify="center">
                  <div class="page-title">Provide updated information for the selected menu</div>
              </v-row>
          </v-col>
      </v-row>
      <v-row>
          <v-col>
              <v-row justify = "center">
                  <v-card flat>
                      <v-img
                        :src= src+menu.imageName
                        width="520"
                      ></v-img>
                      <v-form>
                        <v-text-field
                            outlined
                            dense
                            label="menu name"
                            v-model="menuName"
                            class="mt-10"
                      ></v-text-field>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-checkbox label="Break Fast" v-model="breakfast"></v-checkbox>
                            </v-col>              
                            <v-col cols="12" md="4">
                                <v-checkbox label="Launch" v-model="launch"></v-checkbox>
                            </v-col>
                        
                            <v-col cols="12" md="4">
                                <v-checkbox label="Dinner" v-model="dinner"></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-text-field
                            outlined
                            dense
                            label="price"
                            v-model="price"
                            class="mt-6"
                        ></v-text-field>
                        <v-textarea outlined v-model="description" class="mt-4"></v-textarea>
                        <v-btn class="primary mt-5 text-field" @click="update" width="520px">Update</v-btn> 
                      </v-form>
                  </v-card>
              </v-row>
          </v-col>
      </v-row>
  
      <!-- <v-row>
          <v-col>
              <v-row justify="center">
                <div class="page-title">Provide updated information for the selected menu</div>    
              </v-row>
              <v-row justify="center">
                  <v-card width="520px"  class="mt-8" flat>
                    <v-form>
                      <v-text-field
                        outlined
                        dense
                        label="menu name"
                        v-model="menuName"
                      ></v-text-field>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-checkbox label="Break Fast" v-model="breakfast"></v-checkbox>
                            </v-col>              
                            <v-col cols="12" md="4">
                                <v-checkbox label="Launch" v-model="launch"></v-checkbox>
                            </v-col>
                        
                            <v-col cols="12" md="4">
                                <v-checkbox label="Dinner" v-model="dinner"></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-text-field
                            outlined
                            dense
                            label="menu name"
                            v-model="price"
                        ></v-text-field>
                        <v-textarea outlined v-model="description"></v-textarea>
                        <v-btn class="primary mt-5 text-field" @click="update" width="520px">Update</v-btn> 
                  </v-form>
                  </v-card>
              </v-row>
          </v-col>
      </v-row> -->
  </v-container>
</template>

<script>
import {mapActions} from "vuex"
export default {
    name: "updateMenu",
    props: ["menu"],
    data() {
        return {
            id: this.menu._id,
            menuName: this.menu.menuName,
            breakfast: this.menu.breakfast,
            launch: this.menu.launch,
            dinner: this.menu.dinner, 
            price: this.menu.price,
            description: this.menu.description
        }
    },
    
    computed: {
        src: function() {
            if(process.env.NODE_ENV === 'production') {
                return "/api/images/image?filename="
            } else {
                return "http://localhost:5000/api/images/image?filename="
            }
        }
    },
    methods: {
        ...mapActions(['updateMenu']),
        update() {
            // let item = new FormData();
            // //item.append('image', this.image);
            // item.append('id', this.id);
            // item.append('breakfast', this.breakfast);
            // item.append('MenuName', this.MenuName);
            // item.append('launch', this.launch);
            // item.append('dinner', this.dinner);
            // item.append('description', this.description);
            // item.append('price', this.price);
            let item = {
                id: this.id,
                menuName: this.menuName,
                breakfast: this.breakfast,
                launch: this.launch,
                dinner: this.dinner,
                price: this.price,
                description: this.description
            }
            this.updateMenu(item).then(result => {
                if(result.data.success) {
                    this.$router.push('/Dashboard')
                }else {
                    console.log("Something went wrong, please try again")
                    console.log(result)
                }
            })
        }
    }
}
</script>

<style>
    .page-title {
        font-size: 22px;
        color: gray;
    }
</style>